import React from "react";
import { useHistory } from "react-router-dom";

import { Loader } from "components/request-result";
import Icons from "components/icons";


const ProductServiceCreateButton = ({ className, loading, createProduct }) => {

    const history = useHistory();

    return(
        <>
            <button
                className={`${ className } service`}
                onClick={ () => createProduct(
                    {
                        variables: {
                            type : "product",
                            is_searchable: true,
                            is_top : false
                        },
                        onUpdate: ({ product }) => {
                            history.push(`/product/${product.id}/edit`);
                        },
                    }
                )}
            >
                { loading  ?
                    <Loader  /> : <Icons.CreateProduct type="service" />
                }
                Add any other product or service
            </button>
        </>
    );

};

export default ProductServiceCreateButton;